/*
  Moduły Gabi na karcie produktu (specyfikacja „Moduły karty produktu”).
  Plik ładuje się tylko na kartach, do których dodano blok Gabi.
  - „Gabi · Promocja” i „Gabi · Klub”: cena z rabatem przeliczana po zmianie wariantu,
    kopiowanie kodu, Promocja znika po dacie końca;
  - linijka najniższej ceny z 30 dni odświeżana po zmianie wariantu;
  - <gabi-wielopak> (wielopak 3+1 w polu „Gabi · Cena”): kolor → rozmiar → para na liście,
    plus/minus, cała paczka jednym żądaniem do koszyka.
*/
(function () {
  if (window.gabiKartaModuly) return;
  window.gabiKartaModuly = true;

  var NBSP = ' ';

  function moneyFormat() {
    var root = document.querySelector('[data-gabi-money-format]');
    var fmt = (root && root.getAttribute('data-gabi-money-format')) || '{{amount}} zł';
    return fmt.replace(/<[^>]*>/g, '');
  }

  function formatMoney(cents, format) {
    var fmt = format || moneyFormat();
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = fmt.match(re);
    var value = Math.round(cents) / 100;
    function delim(n, dec, thou, sep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = delim(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delim(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delim(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = delim(value, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = delim(value, 2, "'", '.'); break;
      default: out = delim(value, 2, ',', '.');
    }
    return m ? fmt.replace(re, out) : out;
  }

  function escapeHtml(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function plural(n) {
    // Teksty dla klientek mówią „sztuka”, nie „para” (decyzja Sebastiana 2026-10-02).
    if (n === 1) return 'sztukę';
    var d = n % 10, dd = n % 100;
    return (d >= 2 && d <= 4 && (dd < 10 || dd >= 20)) ? 'sztuki' : 'sztuk';
  }

  function localToday() {
    var d = new Date();
    var pad = function (x) { return (x < 10 ? '0' : '') + x; };
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  /* ---------- Promocja i Klub ---------- */

  function updateDiscounts(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    document.querySelectorAll('[data-gabi-rabat]').forEach(function (el) {
      var pct = parseFloat(el.getAttribute('data-percent'));
      if (!(pct > 0 && pct < 100)) return;
      var target = el.querySelector('[data-gabi-rabat-cena]');
      if (target) target.textContent = formatMoney(Math.round(variant.price * (100 - pct) / 100));
    });
  }

  function hideExpiredPromos() {
    var today = localToday();
    document.querySelectorAll('.gabi-promocja[data-end]').forEach(function (el) {
      if (today > el.getAttribute('data-end')) {
        var wrap = el.closest('.product__gabi-promocja') || el;
        wrap.hidden = true;
        el.hidden = true;
      }
    });
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    ta.remove();
    return ok;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gabi-kod]');
    if (!btn) return;
    var code = btn.getAttribute('data-gabi-kod');
    var label = btn.querySelector('[data-gabi-kod-tekst]');
    var done = function () {
      if (!label) return;
      label.textContent = 'Skopiowano';
      btn.classList.add('is-copied');
      clearTimeout(btn._gabiTimer);
      btn._gabiTimer = setTimeout(function () {
        label.textContent = code;
        btn.classList.remove('is-copied');
      }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { if (fallbackCopy(code)) done(); });
    } else if (fallbackCopy(code)) {
      done();
    }
  });

  function onReady() {
    hideExpiredPromos();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = (event && event.data) || {};
        updateDiscounts(data.variant);
        var html = data.html;
        var src = html && html.querySelector ? html.querySelector('#netkodo-omnibus-price') : null;
        var dst = document.querySelector('#netkodo-omnibus-price');
        if (src && dst) dst.innerHTML = src.innerHTML;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();

  /* ---------- Wielopak 3+1 ---------- */

  var ICON_TRASH = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 8.2c.05.7.6 1.3 1.3 1.3h3.2c.7 0 1.25-.6 1.3-1.3l.6-8.2"/></svg>';

  function optionFieldset(picker, optionName) {
    if (!picker) return null;
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var name = inputs[i].name.trim();
      var cut = name.lastIndexOf('-');
      if ((cut > 0 ? name.slice(0, cut) : name) === optionName) return inputs[i].closest('fieldset');
    }
    return null;
  }

  class GabiWielopak extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var raw = this.querySelector('[data-gabi-wp-dane]');
      try { this.data = JSON.parse(raw.textContent); } catch (e) { return; }
      this._ready = true;
      this.mode = '1';
      this.pack = [];
      this.pending = null;
      this.flash = null;
      this.info = this.closest('.product__content') || document;
      this.picker = this.info.querySelector('product-variant-selects');
      this.body = this.querySelector('[data-gabi-wp-cialo]');
      this.cta = this.querySelector('[data-gabi-wp-cta]');
      this.error = this.querySelector('[data-gabi-wp-blad]');
      this.colorSet = optionFieldset(this.picker, this.dataset.colorOption);
      this.sizeSet = optionFieldset(this.picker, this.dataset.sizeOption);
      this.buy = this.info.querySelector('.product__buy-buttons');
      this.addEventListener('click', this.onClick.bind(this));
      if (this.picker) this.picker.addEventListener('change', this.onPickerChange.bind(this));
      if (this.colorSet) this.colorSet.addEventListener('click', this.onColorClick.bind(this));
      this.setupShine();
    }

    // Lśniący napis „Zestaw 3+1 GRATIS” (decyzja Sebastiana 2026-10-06): błysk w kolorze wyróżnień
    // przechodzi przez napis dwa razy, raz na wizytę — gdy karta zestawu pierwszy raz pojawi się na
    // ekranie. Bez błysku, gdy zestaw jest już wybrany albo telefon ogranicza animacje.
    // Obserwujemy dopiero po `load`: w trakcie ładowania (zdjęcia bez wymiarów) karta bywa chwilowo
    // na ekranie i błysk przechodził, zanim ktokolwiek go zobaczył (sprawdzone na telefonie 06.10).
    setupShine() {
      var text = this.querySelector('[data-gabi-wp-blysk]');
      if (!text || !('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var self = this;
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        setTimeout(function () {
          if (self.mode === '4') return;
          text.addEventListener('animationend', function () { text.classList.remove('is-blysk'); }, { once: true });
          text.classList.add('is-blysk');
        }, 300);
      }, { threshold: 0.6 });
      var start = function () { io.observe(text); };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    }

    variantFor(color, size) {
      for (var i = 0; i < this.data.variants.length; i++) {
        var v = this.data.variants[i];
        if (v.c === color && v.s === size) return v;
      }
      return null;
    }

    total() {
      return this.pack.reduce(function (t, e) { return t + e.q; }, 0);
    }

    prices() {
      var ps = [];
      this.pack.forEach(function (e) { for (var j = 0; j < e.q; j++) ps.push(e.p); });
      return ps.sort(function (a, b) { return a - b; });
    }

    saving() {
      var ps = this.prices(), free = Math.floor(ps.length / 4), s = 0;
      for (var i = 0; i < free; i++) s += ps[i] - 1;
      return s;
    }

    packPrice() {
      return this.prices().reduce(function (t, p) { return t + p; }, 0) - this.saving();
    }

    checkedColor() {
      var c = this.colorSet && this.colorSet.querySelector('input[type="radio"]:checked');
      return c ? c.value : null;
    }

    checkedSize() {
      var s = this.sizeSet && this.sizeSet.querySelector('input[type="radio"]:checked');
      return s ? s.value : null;
    }

    setMode(mode) {
      if (mode === this.mode) return;
      this.mode = mode;
      var multi = mode === '4';
      this.querySelectorAll('[data-gabi-wp-karta]').forEach(function (card) {
        var on = card.getAttribute('data-gabi-wp-karta') === mode;
        card.classList.toggle('is-on', on);
        var head = card.querySelector('[data-gabi-wp-tryb]');
        if (head) head.setAttribute('aria-pressed', String(on));
      });
      this.body.hidden = !multi;
      this.cta.hidden = !multi;
      if (this.buy) this.buy.classList.toggle('gabi-wp-ukryte', multi);
      document.body.classList.toggle('gabi-wp-tryb', multi);
      if (multi) {
        if (!this.pack.length) {
          var c = this.checkedColor(), s = this.checkedSize();
          var v = c && s ? this.variantFor(c, s) : null;
          if (v && v.a) this.addPair(v);
          else if (c) this.pending = c;
        }
      } else {
        this.pending = null;
      }
      this.render();
    }

    addPair(v) {
      var found = null;
      for (var i = 0; i < this.pack.length; i++) if (this.pack[i].id === v.id) found = i;
      if (found !== null) this.pack[found].q = Math.min(99, this.pack[found].q + 1);
      else { this.pack.push({ id: v.id, c: v.c, s: v.s, p: v.p, q: 1 }); found = this.pack.length - 1; }
      this.flash = found;
    }

    // Ten sam kolor co poprzednia sztuka: próbka jest już zaznaczona, więc przeglądarka nie wyśle
    // „change” i wybór kolejnej sztuki trzeba zacząć z kliknięcia (zgłoszenie Sebastiana 2026-10-02).
    onColorClick(e) {
      if (this.mode !== '4') return;
      var input = e.target.closest('input[type="radio"]');
      if (!input) {
        var label = e.target.closest('label[for]');
        input = label ? document.getElementById(label.getAttribute('for')) : null;
      }
      if (!input || !input.checked || !this.colorSet.contains(input)) return;
      this.pending = input.value;
      this.hideError();
      this.render();
    }

    onPickerChange(e) {
      if (this.mode !== '4') return;
      var input = e.target;
      if (!input || input.type !== 'radio' || !this.colorSet || !this.colorSet.contains(input)) return;
      this.pending = input.value;
      this.hideError();
      this.render();
    }

    onClick(e) {
      var el = e.target.closest('[data-gabi-wp-tryb], [data-gabi-wp-rozmiar], [data-gabi-wp-plus], [data-gabi-wp-minus], [data-gabi-wp-cta]');
      if (!el || el.disabled) return;
      this.hideError();
      if (el.hasAttribute('data-gabi-wp-tryb')) {
        this.setMode(el.getAttribute('data-gabi-wp-tryb'));
      } else if (el.hasAttribute('data-gabi-wp-plus')) {
        var i = +el.getAttribute('data-gabi-wp-plus');
        this.pack[i].q = Math.min(99, this.pack[i].q + 1);
        this.flash = i;
        this.render();
      } else if (el.hasAttribute('data-gabi-wp-minus')) {
        var k = +el.getAttribute('data-gabi-wp-minus');
        this.pack[k].q -= 1;
        if (this.pack[k].q <= 0) this.pack.splice(k, 1);
        this.render();
      } else if (el.hasAttribute('data-gabi-wp-cta')) {
        this.submit();
      }
    }

    onSizeClick(size) {
      if (this.pending === null) return;
      var v = this.variantFor(this.pending, size);
      if (!v || !v.a) return;
      this.addPair(v);
      this.pending = null;
      // Ten sam rozmiar w (ukrytym) wyborze motywu: zdjęcie i cena na karcie pokazują dodaną parę.
      if (this.sizeSet) {
        var radios = this.sizeSet.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === size && !radios[i].checked) { radios[i].click(); break; }
        }
      }
      this.render();
    }

    renderSizeRow() {
      if (!this.sizeSet) return;
      var multi = this.mode === '4';
      var row = this.sizeSet.querySelector('.gabi-wp-rozmiary');
      var legendValue = this.sizeSet.querySelector('legend [data-selected-value]');
      this.sizeSet.classList.toggle('gabi-wp-pary', multi);
      this.sizeSet.classList.toggle('gabi-wp-ukryte', multi && this.pending === null);
      if (!multi || this.pending === null) {
        if (row) row.remove();
        if (legendValue && legendValue.hasAttribute('data-gabi-wp-oryginal')) {
          legendValue.textContent = legendValue.getAttribute('data-gabi-wp-oryginal');
          legendValue.removeAttribute('data-gabi-wp-oryginal');
        }
        return;
      }
      if (legendValue) {
        if (!legendValue.hasAttribute('data-gabi-wp-oryginal')) legendValue.setAttribute('data-gabi-wp-oryginal', legendValue.textContent);
        legendValue.textContent = 'dla koloru ' + this.pending;
      }
      if (!row) {
        row = document.createElement('div');
        row.className = 'gabi-wp-rozmiary';
        row.addEventListener('click', function (e) {
          var b = e.target.closest('[data-gabi-wp-rozmiar]');
          if (b && !b.disabled) this.onSizeClick(b.getAttribute('data-gabi-wp-rozmiar'));
        }.bind(this));
        this.sizeSet.appendChild(row);
      }
      var self = this, html = '';
      this.data.sizes.forEach(function (size) {
        var v = self.variantFor(self.pending, size);
        var ok = v && v.a;
        html += '<button type="button" class="gabi-wp-rozmiar' + (ok ? '' : ' is-niedostepny') + '" data-gabi-wp-rozmiar="' + escapeHtml(size) + '"' + (ok ? '' : ' disabled') + ' aria-label="Rozmiar ' + escapeHtml(size) + (ok ? '' : ', niedostępny') + '">' + escapeHtml(size) + '</button>';
      });
      row.innerHTML = html;
    }

    renderBody() {
      var n = this.total(), inSet = n % 4, full = n > 0 && inSet === 0, free = Math.floor(n / 4);
      var h = '<p class="gabi-wp__etykieta">Twój zestaw · ' + (n < 4 ? n + ' z 4 sztuk' : n + ' ' + plural(n)) + '</p>';
      h += '<div class="gabi-wp__pasek' + (full ? ' is-komplet' : '') + '" aria-hidden="true">';
      for (var i = 0; i < 4; i++) h += '<span class="gabi-wp__odcinek' + (i < (full ? 4 : inSet) ? ' is-on' : '') + '"></span>';
      h += '<span class="gabi-wp__cel">1' + NBSP + 'gr</span></div>';
      if (this.pack.length) {
        h += '<ul class="gabi-wp__lista">';
        var self = this;
        this.pack.forEach(function (e, k) {
          var name = escapeHtml(e.c) + ', rozmiar ' + escapeHtml(e.s);
          h += '<li class="gabi-wp__para' + (self.flash === k ? ' is-nowa' : '') + '">';
          h += '<span class="gabi-wp__para-opis"><b>' + escapeHtml(e.c) + '</b> · rozmiar ' + escapeHtml(e.s) + '</span>';
          h += '<span class="gabi-wp__ilosc">';
          h += '<button type="button" data-gabi-wp-minus="' + k + '" aria-label="' + (e.q === 1 ? 'Usuń sztukę: ' : 'Mniej: ') + name + '">' + (e.q === 1 ? ICON_TRASH : '−') + '</button>';
          h += '<span>' + e.q + '</span>';
          h += '<button type="button" data-gabi-wp-plus="' + k + '" aria-label="Więcej: ' + name + '">+</button>';
          h += '</span></li>';
        });
        h += '</ul>';
      }
      var hint;
      if (this.pending !== null) hint = '<b>Teraz rozmiar</b> dla koloru ' + escapeHtml(this.pending) + '. Wybierz go powyżej.';
      else if (n === 0) hint = 'Wybierz kolor powyżej, a potem rozmiar. Każda sztuka może mieć inny kolor i rozmiar.';
      else if (n < 4) hint = 'Dodaj jeszcze ' + (4 - n) + ' ' + plural(4 - n) + ': kolor, potem rozmiar.';
      else if (full) hint = '<b>Komplet.</b> ' + (free === 1 ? 'Czwarta sztuka kosztuje 1' + NBSP + 'gr' : free + ' ' + plural(free) + ' po 1' + NBSP + 'gr') + ', oszczędzasz ' + formatMoney(this.saving()) + '.';
      else hint = 'Masz ' + n + ' ' + plural(n) + ', w tym ' + free + ' za 1' + NBSP + 'gr. Dodaj jeszcze ' + (4 - inSet) + ', a kolejna będzie za 1' + NBSP + 'gr.';
      h += '<p class="gabi-wp__podpowiedz" role="status">' + hint + '</p>';
      this.body.innerHTML = h;
      this.flash = null;
    }

    renderCta() {
      var n = this.total();
      var label;
      if (this.added) label = 'Dodano ' + this.addedCount + ' ' + plural(this.addedCount) + ' ✓';
      else if (n >= 4) label = 'Dodaj ' + n + ' ' + plural(n) + ' · ' + formatMoney(this.packPrice());
      else if (this.pending !== null) label = 'Wybierz rozmiar';
      else label = n === 0 ? 'Wybierz kolor' : 'Wybierz jeszcze ' + (4 - n) + ' ' + plural(4 - n);
      this.cta.textContent = label;
      this.cta.classList.toggle('is-gotowy', n >= 4 && !this.added);
      this.cta.setAttribute('aria-disabled', String(n < 4));
    }

    render() {
      if (this.mode === '4') this.renderBody();
      this.renderSizeRow();
      this.renderColorRow();
      this.renderCta();
    }

    // W trybie zestawu próbka koloru nie wygląda na wybraną, dopóki klientka nie wybiera kolejnej
    // sztuki; nad próbkami samo „Kolor”. Po powrocie do „1 sztuka” — nazwa zaznaczonego koloru.
    renderColorRow() {
      if (!this.colorSet) return;
      var neutral = this.mode === '4' && this.pending === null;
      this.colorSet.classList.toggle('gabi-wp-bez-zaznaczenia', neutral);
      var legendValue = this.colorSet.querySelector('legend [data-selected-value]');
      if (!legendValue) return;
      if (neutral) {
        if (!legendValue.hasAttribute('data-gabi-wp-oryginal')) legendValue.setAttribute('data-gabi-wp-oryginal', legendValue.textContent);
        legendValue.textContent = '';
      } else if (legendValue.hasAttribute('data-gabi-wp-oryginal')) {
        if (this.mode !== '4') legendValue.textContent = this.checkedColor() || legendValue.getAttribute('data-gabi-wp-oryginal');
        legendValue.removeAttribute('data-gabi-wp-oryginal');
      }
    }

    showError(msg) {
      this.error.textContent = msg;
      this.error.hidden = false;
    }

    hideError() {
      this.error.hidden = true;
    }

    pointToNextStep() {
      var target = this.pending !== null ? this.sizeSet : this.colorSet;
      if (!target) return;
      target.classList.remove('gabi-wp-wskaz');
      void target.offsetWidth;
      target.classList.add('gabi-wp-wskaz');
      if (target.getBoundingClientRect().top < 0) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    analytics(items) {
      var dl = window.DL, map = window.__dlPdpVariants;
      if (!dl || typeof dl.push !== 'function' || !map) return;
      var value = 0, list = [];
      items.forEach(function (it) {
        var d = map[it.id];
        if (!d) return;
        value += (parseFloat(d.price) || 0) * it.quantity;
        list.push(typeof dl.buildItem === 'function' ? dl.buildItem(Object.assign({}, d, { quantity: it.quantity })) : d);
      });
      if (!list.length) return;
      dl.push('add_to_cart', {
        component: 'wielopak',
        ecommerce: { currency: (window.__dlGlobals && window.__dlGlobals.currency) || '', value: value, items: list }
      });
    }

    submit() {
      var n = this.total();
      if (n < 4 || this.busy) { if (n < 4) this.pointToNextStep(); return; }
      var packId = 'wp' + Date.now().toString(36);
      var map = window.__dlPdpVariants || {};
      var items = this.pack.map(function (e) {
        var props = { _wielopak: packId };
        var d = map[e.id];
        if (d) {
          var extra = { _dl_color: d.item_color, _dl_size: d.item_size, _dl_den: d.item_den, _dl_cat: d.item_category, _dl_cat2: d.item_category2, _dl_low30: d.item_lowest_price_30d };
          Object.keys(extra).forEach(function (key) { if (extra[key] != null && extra[key] !== '' && extra[key] !== false) props[key] = String(extra[key]); });
        }
        return { id: e.id, quantity: e.q, properties: props };
      });
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var payload = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (s) { return s.section; });
        payload.sections_url = window.location.pathname;
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      var self = this;
      this.busy = true;
      this.cta.classList.add('loading');
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (r) {
          if (!r.ok || r.json.status) {
            self.showError(r.json.description || r.json.message || 'Nie udało się dodać zestawu. Spróbuj jeszcze raz.');
            return;
          }
          self.analytics(items);
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(r.json);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          self.added = true;
          self.addedCount = n;
          self.renderCta();
          setTimeout(function () {
            self.added = false;
            self.pack = [];
            self.render();
          }, 1800);
        })
        .catch(function () {
          self.showError('Nie udało się dodać zestawu. Sprawdź połączenie i spróbuj jeszcze raz.');
        })
        .finally(function () {
          self.busy = false;
          self.cta.classList.remove('loading');
        });
    }
  }

  if (!customElements.get('gabi-wielopak')) customElements.define('gabi-wielopak', GabiWielopak);
})();
